import { useDispatch as useReduxDispatch, useSelector as useReduxSelector, TypedUseSelectorHook } from 'react-redux'
import { UnknownAction } from 'redux'
import { ThunkDispatch } from 'redux-thunk'

type State = any

export type TDispatch = ThunkDispatch<State, any, UnknownAction>
export const useDispatch: () => TDispatch = () => useReduxDispatch()
export const useSelector: TypedUseSelectorHook<State> = useReduxSelector
